<template>
  <label class="checkbox">
            <input
                v-if="group"
                type="checkbox"
                :disabled="disabled"
                :value="label"
                v-model="model"
                :name="name"
                @change="change">
            <input
                v-if="!group"
                type="checkbox"
                :disabled="disabled"
                :checked="currentValue"
                :name="name"
                @change="change">
         <i class="icon-hook"></i>
        <slot><span v-if="showSlot">{{ label }}</span></slot>
    </label>
</template>
<script>
import { findComponentUpward, oneOf } from "../../utils/assist";
import Emitter from "../../mixins/emitter";

const prefixCls = "checkbox";

export default {
  name: "Checkbox",
  mixins: [Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },
    label: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      model: [],
      currentValue: this.value,
      group: false,
      showSlot: true,
      parent: findComponentUpward(this, "CheckGroup")
    };
  },
  computed: {},
  mounted() {
    this.parent = findComponentUpward(this, "CheckGroup");
    if (this.parent) this.group = true;
    if (!this.group) {
      this.updateModel();
      this.showSlot = this.$slots.default !== undefined;
    } else {
      this.parent.updateModel(true);
    }
  },
  methods: {
    change(event) {
      if (this.disabled) {
        return false;
      }

      const checked = event.target.checked;
      this.currentValue = checked;

      let value = checked ? this.trueValue : this.falseValue;
      this.$emit("input", value);

      if (this.group) {
        this.parent.change(this.model);
      } else {
        this.$emit("on-change", value);
        this.dispatch("FormItem", "on-form-change", value);
      }
    },
    updateModel() {
      this.currentValue = this.value === this.trueValue;
    }
  },
  watch: {
    value(val) {
      if (val !== this.trueValue && val !== this.falseValue) {
        throw "Value should be trueValue or falseValue.";
      }
      this.updateModel();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Checkbox/Checkbox.vue